import { render, staticRenderFns } from "./AccountantPortal.vue?vue&type=template&id=15c26a40&scoped=true"
import script from "./AccountantPortal.vue?vue&type=script&lang=ts"
export * from "./AccountantPortal.vue?vue&type=script&lang=ts"
import style0 from "./AccountantPortal.vue?vue&type=style&index=0&id=15c26a40&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c26a40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c26a40')) {
      api.createRecord('15c26a40', component.options)
    } else {
      api.reload('15c26a40', component.options)
    }
    module.hot.accept("./AccountantPortal.vue?vue&type=template&id=15c26a40&scoped=true", function () {
      api.rerender('15c26a40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccountantPortal.vue"
export default component.exports